export enum SlideDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface SlideAnimationState {
  index: number;
  direction: SlideDirection | null;
}
